import React from "react";

export default function DeiBonds({
  size,
  ...rest
}: {
  size: number;
  [x: string]: any;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.84697 0.4776C8.48377 -0.159199 9.51623 -0.159201 10.153 0.4776L11.8339 2.15845H14.211C15.1116 2.15845 15.8416 2.88851 15.8416 3.78908V6.16619L17.5224 7.84697C18.1592 8.48377 18.1592 9.51623 17.5224 10.153L15.8416 11.8338V14.2109C15.8416 15.1115 15.1116 15.8416 14.211 15.8416H11.8339L10.153 17.5224C9.51623 18.1592 8.48377 18.1592 7.84697 17.5224L6.16615 15.8416H3.78913C2.88856 15.8416 2.1585 15.1115 2.1585 14.2109V11.8339L0.4776 10.153C-0.159199 9.51623 -0.159201 8.48377 0.4776 7.84697L2.1585 6.16607V3.78908C2.1585 2.88851 2.88856 2.15845 3.78913 2.15845H6.16612L7.84697 0.4776ZM9 1.63063L6.84155 3.78908L3.78913 3.78908V6.8415L1.63063 9L3.78913 11.1585V14.2109H6.84158L9 16.3694L11.1584 14.2109H14.211V11.1584L16.3694 9L14.211 6.84162V3.78908H11.1585L9 1.63063Z"
        fill="#EBEBEC"
      />
    </svg>
  );
}
